import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const METER_READINGS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('METER_READINGS');
export const METER_READINGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	METER_READINGS_CRUD_ACTION_CONSTANTS
);
